import { breakpoints } from '../constants'

export const isMobile = () => window.innerWidth <= breakpoints.MOBILE
